/** @format */

/* eslint require-await: "warn" -- Legacy code: do not use as an example. */
import { AxiosRequestConfig, CancelToken } from 'axios';

import { client } from '@toucan/client/global/axios';
import { MarketCode } from '@toucan/client/global/market';
import { Model, ModelPriceModifierGroup } from '@toucan/client/global/model';

/**
 * Gets model data by it's id
 *
 * @param modelId {number | string} The model id to get the information for
 * @param market {MarketCode} the market code
 */
export const getModel = async (
    modelId: number | string,
    market: MarketCode,
    cancelToken?: CancelToken
): Promise<Model> => {
    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
        },
        cancelToken,
    };

    const response = await client.get(
        `/public-api/product-service/v1/model/${modelId}/`,
        config
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return response.data;
};

/**
 * Send a post request to the server to subscribe to alerts
 *
 * @param {string} modelId The id of the model we are signing up to alerts for
 * @param {string} emailAddress - The email address to send alerts to
 * @param {MarketCode} market - The market of the user subscribing to alerts
 * @return {promise} A promise representing the response from the api
 */
export const subscribeToModelAlerts = async (
    modelId: number,
    emailAddress: string,
    market: MarketCode,
    csrfToken: string
): Promise<void> => {
    const config: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Market': market.toLowerCase(),
            'CSRF-Token': csrfToken,
        },
    };

    return client.post(
        '/public-api/v1/models/stock-notification/subscribe/',
        {
            emailAddress,
            modelId,
            receiveOffersViaEmail: false,
        },
        config
    );
};

// eslint-disable-next-line @mpb-com/mpb/pure-request-functions -- Legacy code: do not use as an example.
export const unsubscribeToModelAlerts = async (
    authLink: string,
    authLinkAction: string,
    market: MarketCode,
    csrfToken: string,
    modelId?: string
) => {
    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
            'CSRF-Token': csrfToken,
            Authorization: `Authlink ${authLink}`,
            'X-Authlink-Action': authLinkAction,
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    };

    return client.post(
        '/public-api/hashed/models/stock-notification/unsubscribe/',
        { modelId },
        config
    );
};

export async function getPriceModifierGroups(
    modelId: number,
    market: MarketCode
): Promise<ModelPriceModifierGroup[]> {
    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
        },
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const { data } = await client.get(
        `/products/v3/models/${modelId}/modifier-groups/`,
        config
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return data;
}
